import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import Button from '../../Button';
import { IHousing } from '../../../models/employeesHousing.model';
import { getCommonCodeLabel } from '../../../lib/store';
import { Descriptions } from 'antd';
import useAuth from '../../../hooks/useAuth';
import TableEmpty from '../../common/TableEmpty';

interface IProps {
  housing: IHousing|null;
  onOpenEditor: () => void;
}

const StaffHousing: FC<IProps> = ({
  housing, onOpenEditor
}) => {
  const { t, i18n } = useTranslation();
  const { writeAuthYn } = useAuth();

  return (
    <>
      {
        housing
        ? (
          <>
            <div className="comm-bx__between">
              <h3 className='sub-title'>{t('campus.staff.title5')}</h3>
            </div>
            <div className='comm-table__area rowType'>
              <Descriptions
                bordered
                column={2}
                size="small"
              >
                <Descriptions.Item label={t('campus.staff.column13')}>
                  {getCommonCodeLabel('CA0002', housing.contractBrn, i18n.language)}
                </Descriptions.Item>
                <Descriptions.Item label={t('campus.staff.column14')}>
                    {t('campus.staff.column15')}{housing.contractSquare} {t('campus.staff.column16')}
                </Descriptions.Item>
                <Descriptions.Item label={t('campus.staff.column17')}>
                  {moment(housing.contractDate).format('YYYY.MM.DD')}
                </Descriptions.Item>
                <Descriptions.Item label={t('campus.staff.column18')}>
                  {moment(housing.contractExpireDate).format('YYYY.MM.DD')}
                </Descriptions.Item>
                <Descriptions.Item label={t('campus.staff.column19')}>
                  {t('campus.staff.column20')}{housing.totalWrtAmt} {t('campus.staff.column21')}
                </Descriptions.Item>
                <Descriptions.Item label={t('campus.staff.column22')}>
                  {t('campus.staff.column20')}{housing.monthLeaseAmount} {t('campus.staff.column21')}
                </Descriptions.Item>
                  <Descriptions.Item label={t('common.text.address1')} span={2}>
                  {`(${housing.zipNo}) ${housing.address}`}
                </Descriptions.Item>
                  <Descriptions.Item label={t('common.text.address2')} span={2}>
                  {housing.detailAddress}
                </Descriptions.Item>
              </Descriptions>
            </div>

            <div className="comm-bx__between mt-4">
              <h3 className='sub-title'>{t('campus.staff.title6')}</h3>
            </div>
            <div className='comm-table__area rowType'>
              <Descriptions
                bordered
                column={2}
                size="small"
              >
                  <Descriptions.Item label={t('campus.staff.column23')}>
                  {housing.leaseholderName}
                </Descriptions.Item>
                  <Descriptions.Item label={t('campus.staff.column24')}>
                  {housing.leaseholderTelephone}
                </Descriptions.Item>
                <Descriptions.Item label={t('campus.staff.column25')} span={2}>
                  {`${getCommonCodeLabel('SY0007', housing.bankCode, 'ko')} ${housing.accountNo}`}
                </Descriptions.Item>
                <Descriptions.Item label={t('campus.staff.column26')}>
                  {housing.brokerName}
                </Descriptions.Item>
                <Descriptions.Item label={t('campus.staff.column27')}>
                  {housing.brokerTelephone}
                </Descriptions.Item>
                <Descriptions.Item label={t('campus.staff.column28')} span={2}>
                  {
                    housing.attachFileCode
                      ? (
                        <>
                          <a
                            className="download-link"
                            href={housing.fileLocation}
                            download={housing.originalName}
                          >
                            {housing.originalName}
                          </a>
                        </>
                      )
                      : null
                  }            
                </Descriptions.Item>
              </Descriptions>
            </div>
          </>
          )
        : (
          <TableEmpty text={t('campus.staff.text3')} />
          )
      }

      <div className="comm-bx__space">
        <div className="comm-btn__area right">
          <Button
            className='btn-basic pink-line'
            onClick={onOpenEditor}
            text={housing ? t('common.button.edit') : t('campus.staff.button4')}
            writeAuthYn={writeAuthYn}          
          />
        </div>
      </div>
    </>
  );

}

export default StaffHousing;
